export const generateInviteText = (roomId, meetingLink) => {
    return `You're invited to a Zimpeer meeting

Meeting ID: ${roomId}
Join Link: ${meetingLink}

No downloads required. Join directly from your browser.`;
};